import { Select } from "antd";
import React, { useEffect } from "react";
import { CaretDownOutlined } from "@ant-design/icons";
import "./LanguageDropdown.css";
import { useTranslation } from "react-i18next";

const { Option, OptGroup } = Select;

const LanguageDropdown = () => {
  const { i18n } = useTranslation();

  const handleChange = (value) => {
    i18n.changeLanguage(value);
    localStorage.setItem("locale", value);
    window?.Moengage?.track_event("customer_webflow_language", {
      flow: sessionStorage.getItem("isCreditScoreCheck")
        ? "Credit Score Check"
        : "Customer Addition",
      language: value == "en" ? "English" : value == "hi" ? "Hindi" : "Telugu",
    });
  };

  useEffect(() => {
    if (localStorage?.getItem("locale") == null) {
      localStorage.setItem("locale", "en");
      window?.Moengage?.track_event("customer_webflow_language", {
        flow: sessionStorage.getItem("isCreditScoreCheck")
          ? "Credit Score Check"
          : "Customer Addition",
        language: "English",
      });
    }
  }, []);

  return (
    <>
      <Select
        defaultValue={
          i18n.language
            ? i18n.language == "en"
              ? "en"
              : i18n.language == "hi"
              ? "hi"
              : "te"
            : "en"
        }
        bordered={false}
        style={{
          width: "120px",
          backgroundColor: "#F2F2F2",
          borderRadius: "8px",
        }}
        onChange={handleChange}
        suffixIcon={<CaretDownOutlined />}
        dropdownMatchSelectWidth={false}
        dropdownStyle={{
          width: "150px",
          //   border:"1px solid red",
        }}
      >
        <OptGroup
          label="Choose Language"
          style={{
            fontWeight: "900 !important",
          }}
        >
          <Option value="en" className="option">
            English
          </Option>
          <Option value="hi" className="option">
            Hindi
          </Option>
          <Option value="te" className="option">
            Telugu
          </Option>
        </OptGroup>
      </Select>
    </>
  );
};
export default LanguageDropdown;
